// ##############################
// // // Dashboard View styles
// #############################

import {
  successColor,
  dangerColor,
  tooltip,
  defaultFont
} from "assets/jss/material-dashboard-pro-react.jsx";
import tableStyle from "assets/jss/material-dashboard-pro-react/components/tableStyle.jsx";

const dashboardStyle = {
  successText: {
    color: successColor
  },
  upArrowCardCategory: {
    width: 14,
    height: 14
  },
  underChartIcons: {
    width: "17px",
    height: "17px"
  },
  tooltip,
  ...tableStyle,
  table: {
    display: "block",
    marginBottom: "0",
    width: "100%",
    maxWidth: "100%",
    backgroundColor: "transparent",
    borderSpacing: "0",
    borderCollapse: "collapse",
    overflow: "auto",
    paddingBottom: "20px"
  },
  tableHeadCell: {
    color: "rgba(0, 0, 0, 0.87)",
    border: "none !important",
    padding: "12px 10px"
  },
  tableCell: {
    ...defaultFont,
    lineHeight: "1.42857143",
    padding: "12px 10px!important",
    verticalAlign: "middle",
    fontSize: "1em",
    borderBottom: "none",
    borderTop: "1px solid #ddd",
    position: "relative",
  },
  danger: {
    color: dangerColor
  },
  success: {
    color: successColor
  },
};

export default dashboardStyle;



// WEBPACK FOOTER //
// ./src/assets/jss/material-dashboard-pro-react/views/dashboardStyle.jsx